import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Container from "../components/Container";
import SectionTitle from "../components/Home/SectionTitle";
import { useSiteContent } from "../context/SiteContentContext";

const defaultContent = {
  hero: {
    eyebrow: "للتواصل",
    title: "تواصل مع رعية مار الياس",
    description: "صفحة عربية بسيطة تجمع وسائل التواصل الأساسية الخاصة بالرعية.",
  },
  visit: {
    eyebrow: "الرعية",
    title: "رعية مار الياس - فسوطة",
    description: "بيانات التواصل الأساسية.",
    image: "/media/gallery/new-church.jpg",
    badge: "",
  },
  details: [],
  notesTitle: "ملاحظات",
  notes: [],
};

export default function Contact() {
  const [content, setContent] = useState(defaultContent);
  const { tables } = useSiteContent();

  useEffect(() => {
    fetch("/data/contact.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`تعذّر تحميل صفحة التواصل: ${response.status}`);
        }

        return response.json();
      })
      .then((json) => {
        setContent({
          ...defaultContent,
          ...json,
          hero: {
            ...defaultContent.hero,
            ...json.hero,
          },
          visit: {
            ...defaultContent.visit,
            ...json.visit,
          },
          details: json.details ?? defaultContent.details,
          notes: json.notes ?? defaultContent.notes,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <main className="pb-20">
      <section className="pb-8 pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#f3eee5] px-6 py-10 text-right md:px-10 lg:flex lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-sm font-bold text-[#8a7355]">
                {content.hero.eyebrow}
              </p>
              <SectionTitle
                title={content.hero.title}
                classes="mt-3 text-[#3e352b]"
              />
              <p className="mt-4 max-w-2xl text-[16px] leading-7 text-[#5d5348]">
                {content.hero.description}
              </p>
            </div>

            <Link
              to="/"
              className="mt-6 inline-flex rounded-full border border-[#8a7355] px-5 py-3 text-sm font-bold text-[#5d5348] transition-colors hover:bg-[#8a7355] hover:text-white lg:mt-0"
            >
              {tables.backHomeLabel}
            </Link>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <div className="grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
            <article className="overflow-hidden rounded-[32px] border border-[#eadfce] bg-white shadow-[0_18px_60px_rgba(76,58,37,0.08)]">
              <img
                src={content.visit.image}
                alt={content.visit.title}
                className="h-[280px] w-full object-cover"
              />
              <div className="p-6 text-right md:p-8">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <p className="text-sm font-bold text-[#8a7355]">
                    {content.visit.eyebrow}
                  </p>
                  {content.visit.badge ? (
                    <span className="rounded-full bg-[#f4ede2] px-4 py-2 text-xs font-bold text-[#7b674d]">
                      {content.visit.badge}
                    </span>
                  ) : null}
                </div>
                <h2 className="mt-4 text-[30px] font-bold text-[#2f281f]">
                  {content.visit.title}
                </h2>
                <p className="mt-4 text-[16px] leading-8 text-[#5d5348]">
                  {content.visit.description}
                </p>
              </div>
            </article>

            <div className="grid gap-4">
              {content.details.map((detail) => (
                <article
                  key={detail.label}
                  className="rounded-[28px] border border-[#eadfce] bg-white p-6 text-right shadow-[0_18px_60px_rgba(76,58,37,0.08)]"
                >
                  <p className="text-sm font-bold text-[#8a7355]">
                    {detail.label}
                  </p>
                  <a
                    href={detail.href}
                    className="mt-3 inline-flex text-[26px] font-bold text-[#2f281f] transition-colors hover:text-[#8a7355]"
                  >
                    {detail.value}
                  </a>
                  <p className="mt-3 text-[15px] leading-7 text-[#5d5348]">
                    {detail.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#212121] px-6 py-10 text-right text-white md:px-10">
            <p className="text-sm font-bold text-[#d9cab3]">
              {content.notesTitle}
            </p>
            <ul className="mt-4 space-y-3 text-[16px] leading-8 text-[#ddd5cb]">
              {content.notes.map((note) => (
                <li key={note} className="relative pr-6">
                  <span className="absolute right-0 top-[14px] h-2 w-2 rounded-full bg-[#d9cab3]" />
                  {note}
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </section>
    </main>
  );
}
